import { render, staticRenderFns } from "./SwitchStateButton.vue?vue&type=template&id=28db3ebb&scoped=true&"
import script from "./SwitchStateButton.vue?vue&type=script&lang=ts&"
export * from "./SwitchStateButton.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchStateButton.vue?vue&type=style&index=0&id=28db3ebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db3ebb",
  null
  
)

export default component.exports